module.exports = __webpack_public_path__ + "img/popup-game-sucai.cbe8069b.png";